import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import { IDeleteTipMenuItemRequest, IToggleTipMenuStatusRequest, IUpdateTipMenuDataRequest } from "./request.types";
import type { TGetTipMenuDataResponse, TGetTipMenuStatusResponse } from "./response.types";

class TipMenuController extends Controller {
	public constructor() {
		super({ requestUrl: "models/tipMenu" });
	}

	/** @GET TIP MENU STATUS */
	public async getTipMenuStatus({ token }: IRequestConfig) {
		return this.get<TGetTipMenuStatusResponse>("base", "/enabled", { token });
	}

	/**@PUT TOGGLE TIP MENU STATUS */
	public async toggleTipMenuStatus({ token, enabled }: IToggleTipMenuStatusRequest) {
		return this.put<void>("/enable", { enabled }, { token });
	}

	/**@GET TIP MENU DATA */
	public async getTipMenuData({ token }: IRequestConfig) {
		return this.get<TGetTipMenuDataResponse>("base", "", { token });
	}

	/**@POST UPDATE TIP MENU DATA */
	public async updateTipMenuData({ token, items }: IUpdateTipMenuDataRequest) {
		return this.post("", { items }, { token });
	}

	/**@DELETE TIP MENU ITEM */
	public async deleteTipMenuItem({ id, token }: IDeleteTipMenuItemRequest) {
		return this.delete<void>(`/${id}`, { token });
	}
}

export const tipMenuAPI = new TipMenuController();
